import React, {Component} from 'react';
import { EDITOR_MOBILE_LEFT_BAR_MENU_ID } from 'crazyEditor/core/constants/editorConstants';
import { connect } from 'react-redux';
import _ from 'lodash';
import { showMobileElement } from 'crazyEditor/redux/modules/element/actions/mobileElementActions';
import styles from './EditorLeftBarStyles';
import MenuElement from './MenuElement/MenuElement';
import Radium from 'radium';
import { getHiddenMobileElements } from 'crazyEditor/redux/modules/element/elementSelectors';
const classes = require('./DesktopEditorLeftBar.scss');

@connect(
  state => ({
    hiddenMobileElements: getHiddenMobileElements(state),
    stageLayoutTop: state.stage.layout.top
  }),
  {showMobileElement}
)
@Radium
export default class MobileEditorLeftBar extends Component {

  render() {
    const {showMobileElement, hiddenMobileElements, stageLayoutTop} = this.props;
    if (_.isEmpty(hiddenMobileElements)) return null;

    return (
      <div id={EDITOR_MOBILE_LEFT_BAR_MENU_ID}
           className={classes.leftMenu}
           style={[styles.mobileContainer, styles.containerExpanded, {top: stageLayoutTop, overflowY: 'auto', overflowX: 'hidden'}]}>
        <span style={styles.menuTitle}>HIDDEN ELEMENTS</span>
        <ul style={styles.menuContainer}>

          {
            _.map(hiddenMobileElements, (element, index) =>
              <li key={index} onClick={() => showMobileElement(element.id)}>
                <MenuElement elementType={element.type} responsive={false}/>
              </li>)
          }
        </ul>
      </div>
    );
  }
}

